import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { memo } from 'react';

const Keywords = dynamic(() => import('./Keywords'));

const RelatedCategories = ({
  categories,
  gaEventCategory,
  storeParam,
  storeName,
}) => {
  if (categories.length === 0) {
    return null;
  }

  return (
    <Keywords
      categories={categories}
      gaEventCategory={gaEventCategory}
      storeName={storeName}
      storeParam={storeParam}
    />
  );
};

RelatedCategories.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      subcategoryId: PropTypes.number,
      subcategoryName: PropTypes.string,
    })
  ),
  gaEventCategory: PropTypes.string.isRequired,
  storeName: PropTypes.string,
  storeParam: PropTypes.string,
};

export default memo(RelatedCategories);
